const ttl = {
    interaction: 10 * 60 * 1000,       // 10 minutes
};

export default ttl;